import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { determineAssekuranztarifFromTarifbereich } from '@ps20-frontend/frontend-models';

export const assekuranztarifReducer = function (
  sectionState: boolean = false,
  action: AnyAction,
): boolean {
  switch (action.type) {
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD: {
      return action.payload;
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return determineAssekuranztarifFromTarifbereich(action.payload);
    }
    default:
      return sectionState;
  }
};
